module.exports = __webpack_public_path__ + "static/media/btn_tree_active.cc0ede6c.png";